import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import HomepageBL from './HomepageBL';
import AccountsActionCreator from '../../actions/AccountsActionCreator';
import {
  accountHasLimitedRead,
  accountHasProjections,
  accountHasSavingsPot,
} from '../../utils/AccountCapabilityUtils';
import { isB } from '../../utils/BrandUtils';
import { getAccountInfoContent } from './AccountCardUtils';
import { AccountDetailsCard } from './AccountDetailsCard';

class AccountCardHomePage extends React.Component {
  constructor(props) {
    super(props);
    this.getAccountBalances = this.getAccountBalances.bind(this);
    this.goToAccountDetails = this.goToAccountDetails.bind(this);
    this.getAccountDetails = this.getAccountDetails.bind(this);
    this.getWarningIcon = this.getWarningIcon.bind(this);
    const { account } = props;
    this.state = {
      balances: HomepageBL.getBalances(account) || {},
      showAccountName: !isB() && account.accountName,
    };
  }
  componentWillReceiveProps(nextProps) {
    this.setBalances(nextProps);
  }
  getAccountBalances() {
    const { account } = this.props;
    const { balances } = this.state;

    const accNo = HomepageBL.getAccountDisplayNumber(account);
    const toShowAvailableBalance =
      HomepageBL.shouldShowAvailableBalance(account);
    const accountInfo = getAccountInfoContent(account);
    return (
      <AccountDetailsCard
        accountInfo={accountInfo}
        sortCode={accNo.sortcode}
        accountNumber={accNo.accountNumber || accNo}
        balance={
          balances.currentBalance ? balances.currentBalance : 'unavailable'
        }
        remaining={
          toShowAvailableBalance && balances.availableBalance !== ''
            ? `${balances.availableBalance} available`
            : ''
        }
        isBalanceDisplayed={!accountHasLimitedRead(account)}
      />
    );
  }
  getAccountDetails(e) {
    e.preventDefault();
    AccountsActionCreator.getAccountDetails(this.props.account.id);
  }
  getWarningIcon() {
    const { account, content } = this.props;
    if (account.showIcon) {
      let errorText = accountHasProjections(account)
        ? content.warningIconTextProjection
        : '';
      errorText = accountHasSavingsPot(account)
        ? content.warningIconTextRejigCase
        : errorText;
      return (
        <p className="c-rejig">
          <span className="c-rejig__text">
            <strong>Error</strong>: {errorText}
          </span>
          <span className="c-rejig__icon icon icon-error-1" />
        </p>
      );
    }
  }
  setBalances(props) {
    this.setState({
      balances: HomepageBL.getBalances(props.account),
    });
  }
  goToAccountDetails(e) {
    const { goToAccountDetails, account } = this.props;
    e.preventDefault();
    goToAccountDetails(account.id);
  }
  render() {
    const { index, account } = this.props;
    const { showAccountName } = this.state;
    return (
      <div
        role="group"
        aria-label={account.displayName}
        data-test-id={`account${index + 1}`}
        className={classnames('c-account c-account@medium l-tile', {
          'l-tile--large l-tile--primary': index === 0,
        })}
      >
        {showAccountName && <div>{account.accountName}</div>}
        <h2 id={`account ${index + 1}`} className="c-account__title">
          <button className="c-account__link" onClick={this.goToAccountDetails}>
            {account.displayName}
          </button>
        </h2>
        {this.getWarningIcon()}
        {this.getAccountBalances()}
      </div>
    );
  }
}

AccountCardHomePage.propTypes = {
  account: PropTypes.object,
  content: PropTypes.object,
  goToAccountDetails: PropTypes.func,
  index: PropTypes.number,
};

export default AccountCardHomePage;
